module.exports = __webpack_public_path__ + "img/7_43.2ac96c14.png";